import {Reducer} from 'redux';
import {ModuloState, ModuloTypes} from './types';
import {LoginTypes} from '../login/types';

const CHAVE_MODULO = 'admin-modulo';

// Preferencia de tela guardada no navegador, so por conforto: o acesso e
// revalidado antes de usar.
const ler = (chave: string): string | null => {
    try {
        return localStorage.getItem(chave);
    } catch (e) {
        return null;
    }
};

const gravar = (chave: string, valor: string | null) => {
    try {
        valor === null ? localStorage.removeItem(chave) : localStorage.setItem(chave, valor);
    } catch (e) {
        // Sem storage o seletor so nao lembra entre visitas.
    }
};

export const INITIAL_STATE: ModuloState = {
    atual: ler(CHAVE_MODULO),
};

const reducer: Reducer<ModuloState> = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ModuloTypes.SELECIONAR:
            gravar(CHAVE_MODULO, action.payload);
            return {...state, atual: action.payload};
        case LoginTypes.LOGGING_OFF:
            // Outro usuario pode entrar em seguida, com outros modulos.
            gravar(CHAVE_MODULO, null);
            return {atual: null};
        default:
            return state;
    }
};

export default reducer;
